// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCardStyles } from "@bg/Overrides/Widgets/ProductList/ProductListProductCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCardStyles.actionsWrapper = {
    css: css`
        width: 300px;
        min-width: 300px;
        padding-left: 20px;
        border-left: 1px solid ${getColor("common.ui2")};
    `,
};
